import * as THREE from "three";

export default class OceanHotspot extends THREE.Group {
  constructor(config) {
    super();

    this.config = config;
    const g = new THREE.SphereBufferGeometry(0.08, 10, 10);
    const m = new THREE.MeshBasicMaterial({ color: 0x37bbc8 });
    // m.transparent = true;
    // m.opacity = 0.0;

    this.material = m;

    const s = new THREE.Mesh(g, m);
    s.position.x = config.x;
    s.position.y = config.y;
    s.position.z = config.z;
    this.add(s);

    // s.renderOrder = -1;
    this.object = s;
  }

  getOpacity() {
    return this.material.opacity;
  }

  setOpacity(opacity) {
    this.material.opacity = opacity;

    if (opacity >= 1) {
      this.material.transparent = false;
    }
  }

  getObject() {
    return this.object;
  }

  getImage() {
    return this.config.image;
  }

  setScale(scale) {
    this.object.scale.setScalar(scale);
  }
}
